import isEqual from 'lodash/isEqual'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment-timezone'
// eslint-disable-next-line
import { tripPlanPointInfo, tripPlanInfo } from '@/store/modules/trip-plan'
import { calculateServerRouting } from '@/api/heremap'
import { getTimeZone } from '@/config/time-zone'
import { parseServerRoutingResp } from '@/server-routing/services/route'

class tripPlanService {
  constructor() {}
  getStopPointType(info, index, length) {
    if (index === 0) {
      return 'origin'
    } else if (index === length - 1) {
      return 'target'
    } else {
      return 'waypoint'
    }
  }
  /**
   * 删除一个途经点
   *
   * @param {Array} points 旅行计划的所有途经点
   * @param {Number} index 要删除途经点的索引
   * @memberof tripPlanService
   */
  removePoint(points, id) {
    let list = [...points].filter(item => item.uniqueIdentifier !== id)
    return this.addWaypoint(list, null)
  }
  foramtVia(via, waypointIndex) {
    return (via || []).map((item, index) => {
      return {
        ...item,
        dragInfo: {
          waypointIndex,
          viaIndex: index
        }
      }
    })
  }
  /**
   * 添加途经点
   *
   * @param {Array} points 旅行计划的所有途经点
   * @param {tripPlanPointInfo} point 途经点信息
   * @memberof tripPlanService
   */
  addWaypoint(points, point) {
    let list = [...points, point].filter(item => !!item)
    let currentIndex = 0
    return list.map((item, index) => ({
      ...item,
      via: this.foramtVia(item.via, currentIndex),
      originalIndex: item.hidden ? null : currentIndex++,
      departureTime: index === 0 ? item.departureTime || moment().format('YYYY-MM-DD HH:mm:ss') : '',
      dwellTime: index === list.length - 1 ? '' : item.dwellTime,
      stopPointType: this.getStopPointType(item, index, list.length),
      uniqueIdentifier: item.uniqueIdentifier ? item.uniqueIdentifier : `${item.pointId}-${item.latitude}-${item.longitude}-${Date.now() 
      + index}`
    }))
  }
  /**
   * 计算出发时间
   *
   * @param {Array} points
   * @returns
   * @memberof tripPlanService
   */
  calculateDepartureTime(points) {
    let route = points.filter(item => item.stopPointType === 'origin')
    let defaultTime = moment().format('YYYY-MM-DD HH:mm:ss')
    let departureTime = route[0].departureTime ? route[0].departureTime : defaultTime
    let timeZone = route[0].timeZoneFull || route[0].timeZone || 'EST'
    return moment.tz(departureTime, getTimeZone(timeZone)).format('YYYY-MM-DDTHH:mm:ssZ')
  }
  /**
   * 格式化停留时间
   *
   * @param {*} dwellTime
   * @param {string} [unit='second'] 单位(秒和分钟) 默认为秒
   * @returns
   * @memberof tripPlanService
   */
  formatDwellTime (dwellTime, unit='second') {
    let date = moment(dwellTime, 'HH:mm')
    let hours = date.hours()
    let minutes = date.minutes()
    if (unit === 'second') {
      return (hours * 60 + minutes) * 60
    }
    return hours * 60 + minutes
  }
  /**
   *
   * 计算英寸
   * @param {Number | String} feet 英尺
   * @param {Number | String} inche 英寸
   * @returns
   * @memberof tripPlanService
   */
  calculateHowManyInches(feet, inche) {
    feet = Number(feet) || 0
    inche = Number(inche) || 0
    return feet * 12 + inche
  }
  /**
   * 格式化接口参数
   *
   * @param {Object} params
   * @returns
   * @memberof tripPlanService
   */
  filterParams(params) {
    var newPar = {}
    for (var key in params) {
      if (params[key] && params[key].toString().replace(/(^\s*)|(\s*$)/g, '') !== '') {
        newPar[key] = params[key]
      }
    }
    return newPar
  }
  /**
   * 获取路线上点的位置列表
   *
   * @param {Object} route 路线
   * @returns
   * @memberof tripPlanService
   */
  calculateShape(route) {
    const shapes = route.shape || []
    let positions = []
    for (let i = 0; i < shapes.length; i++) {
      positions.push({ lat: shapes[i][0], lng: shapes[i][1] })
    }
    return positions
  }
  /**
   * 计算路线
   *
   * @param {tripPlanInfo} tripPlanInfo 旅行计划的信息
   * @param {Object} extraParams 附加的参数
   * @param {String} userId 用户id
   * @param { Object } cancelToken 请求token
   * @memberof tripPlanService
   */
  calculateRoute(tripPlanInfo, extraParams, userId, cancelToken) {
    return new Promise((resolve, reject) => {
      let tripPlanPoints = tripPlanInfo.tripPlanPoints.filter(item => item.value)
      let points = tripPlanPoints.map((item, i) => {
        return Object.assign({}, item, {
          dwellTime: i === 0 || i === tripPlanPoints.length - 1 ? 0 : this.formatDwellTime(item.dwellTime),
          pointType: item.pointType === 'fuelStation' ? 'poi' : item.pointType,
          id: ['poi', 'fuelStation'].includes(item.pointType) ? item.poiId : item.pointType === 'facility' ? item.facilityId : ''
        })
      })
      let settingList = tripPlanInfo.settingList
      let truckInfo = tripPlanInfo.truckInfo
      let gangerousGoods = truckInfo.checkedDangerousGoods || []
      let length = this.calculateHowManyInches(truckInfo.lengthFt, truckInfo.lengthIn)
      let width = this.calculateHowManyInches(truckInfo.widthFt, truckInfo.widthIn)
      let height = this.calculateHowManyInches(truckInfo.heightFt, truckInfo.heightIn)
      let grossWeight = (truckInfo.grossWeight || '').replace(/[^0-9]/g, '')
      let weightPerAxle = (truckInfo.weightPerAxle || '').replace(/[^0-9]/g, '')
      let params = Object.assign({
        app_id: process.env.VUE_APP_HERE_MAP_APP_ID,
        app_code: process.env.VUE_APP_HERE_MAP_APP_CODE,
        length: length,
        width: width,
        height: height,
        alternatives: 3,
        limitedWeight: grossWeight,
        weightPerAxle: weightPerAxle,
        axleCount: truckInfo.axles,
        trailersCount: truckInfo.trailers,
        departure: this.calculateDepartureTime(tripPlanPoints),
        shippedHazardousGoods: gangerousGoods.join(','),
        routeSetting: settingList,
        mode: isEmpty(truckInfo) ? 'car' : 'truck',
        wayPoints: points,
        routeDescription: `${userId}_${moment().format('x')}`
      }, extraParams)
      calculateServerRouting(this.filterParams(params), cancelToken).then(
        routeList => {
          let result = this.formatCalculateRouteResult(routeList, tripPlanPoints)
          resolve(result)
        },
        error => {
          try {
            let message = 'Failed to create a route, please change conditions and try again'
            if (error.message && ['cancel request', 'cancel route request'].includes(error.message)) {
              message = error.message
            }
            reject(message)
          } catch {
            reject('Failed to create a route, please change conditions and try again')
          }
        }
      )
    })
  }
  accumulativeResidenceTime(list) {
    return list.reduce((a,b) => a + b.summary.durationAndDwellTime, 0)
  }
  accumulativeResidenceDistance(list) {
    return list.reduce((a,b) => a + b.summary.length, 0)
  }
  accumulativeResidenceCost(list) {
    return list.reduce((a,b) => a + b.summary.tollCost, 0)
  }
  /**
   * 获取路线的途径点详情信息
   *
   * @param {Object} route 路线
   * @param {Array} routePoints 路线的点的列表
   * @returns
   * @memberof tripPlanService
   */
   getRouteWaypoint(route, routePoints) {
    let sections = route.sections
    let summary = route.summary
    let originPoint = routePoints[0]
    let timeZone = originPoint.timeZone || 'EST'
    let timeZoneFull = originPoint.timeZoneFull || timeZone
    let timeZoneName = getTimeZone(timeZoneFull)
    let waypoint = route.waypoint
    let lastPointNotHidden = 0
    let waypointList = routePoints.map((item, index, arr) => {
      let detail = Object.assign({}, item, waypoint[index], {
        via: item.via,
        departureTime: item.departureTime,
        title: item.value,
        timeZone: timeZone,
        timeZoneFull: timeZoneFull,
        dwellTime: item.dwellTime,
        departTime: null, // 出发时间
        departDate: null,
        arrivalTime: null, // 到达时间
        arrivalDate: null, // 到达日期
        stayTime: null, // 停留时间

        distance: null, // 总距离
        tollCost: null, // 通行费
        drivingTime: null, // 行车时间,单位为s
        drivingTimeHours: null,
        drivingTimeMinutes: null,
        
        distanceIncludingHiddenPoints: null, // Total distance including hidden points
        tollCostIncludingHiddenPoints: null, // Total cost including hidden points
        drivingTimeIncludingHiddenPoints: null,
        drivingTimeHoursIncludingHiddenPoints: null,
        drivingTimeMinutesIncludingHiddenPoints: null,

        totalTimeHours: null,
        totalTimeMinutes: null,
        _totalDistance: null,
        _totalCost: null
      })

      let sectionsInfo = sections[index - 1] || {}
      let sectionSummary = sectionsInfo.summary
      if (sectionSummary) {
        detail.distance = sectionSummary.length
        detail.tollCost = sectionSummary.tollCost // 待定
        detail.drivingTime = sectionSummary.duration
        detail.drivingTimeHours = parseInt(sectionSummary.duration / 3600)
        detail.drivingTimeMinutes = Math.round((sectionSummary.duration - detail.drivingTimeHours * 3600) / 60)
      }
      if (!item.hidden) {
        if (index > lastPointNotHidden + 1) {
          let sectionsInfoIncludingHiddenPoints = sections.slice(lastPointNotHidden, index)
          detail.distanceIncludingHiddenPoints = this.accumulativeResidenceDistance(sectionsInfoIncludingHiddenPoints)
          detail.tollCostIncludingHiddenPoints = this.accumulativeResidenceCost(sectionsInfoIncludingHiddenPoints)
          detail.drivingTimeIncludingHiddenPoints = sectionsInfoIncludingHiddenPoints.reduce((a,b) => a + b.summary.duration, 0)
          detail.drivingTimeHoursIncludingHiddenPoints = parseInt(detail.drivingTimeIncludingHiddenPoints / 3600)
          detail.drivingTimeMinutesIncludingHiddenPoints = Math.round((detail.drivingTimeIncludingHiddenPoints - detail.drivingTimeHoursIncludingHiddenPoints * 3600) / 60)
        }
        lastPointNotHidden = index
      }


      if (index === 0) {
        detail.arrivalDate = moment(summary.departure, 'X').tz(timeZoneName).format('MMM DD')
        detail.arrivalTime = moment(summary.departure, 'X').tz(timeZoneName).format('HH:mm')
        detail.departDate = moment(summary.departure, 'X').tz(timeZoneName).format('MMM DD')
        detail.departTime = moment(summary.departure, 'X').tz(timeZoneName).format('HH:mm')
      } else if (index === arr.length - 1) {
        detail.arrivalDate = moment(summary.arrival, 'X').tz(timeZoneName).format('MMM DD')
        detail.arrivalTime = moment(summary.arrival, 'X').tz(timeZoneName).format('HH:mm')
        detail.totalTimeHours = parseInt(summary.duration / 3600)
        detail.totalTimeMinutes = Math.round((summary.duration - detail.totalTimeHours * 3600) / 60)
        detail._totalDistance = summary.distance
        detail._totalCost = summary.totalCost
      } else {
        let baseTime = this.accumulativeResidenceTime(sections.slice(0, index))
        detail.arrivalDate = moment(summary.departure, 'X').add(baseTime, 's').tz(timeZoneName).format('MMM DD')
        detail.arrivalTime = moment(summary.departure, 'X').add(baseTime, 's').tz(timeZoneName).format('HH:mm')
        detail.stayTime = item.dwellTime ? this.formatDwellTime(item.dwellTime, 'minute') : null
        detail.departDate = moment(summary.departure, 'X').add(baseTime, 's').add(detail.stayTime, 'm').tz(timeZoneName).format('MMM DD')
        detail.departTime = moment(summary.departure, 'X').add(baseTime, 's').add(detail.stayTime, 'm').tz(timeZoneName).format('HH:mm')
        detail.totalTimeHours = parseInt(baseTime / 3600)
        detail.totalTimeMinutes = Math.round((baseTime - detail.totalTimeHours * 3600) / 60)
        detail._totalDistance = this.accumulativeResidenceDistance(sections.slice(0, index))
        detail._totalCost = this.accumulativeResidenceCost(sections.slice(0, index))
      }
      return detail
    })
    return waypointList
  }
  /**
   * 格式化计算路线结果
   *
   * @param {*} routes 路线列表
   * @param {*} points 旅行计划所有途经点
   * @returns
   * @memberof tripPlanService
   */
  formatCalculateRouteResult(routes, routePoints) {
    try {
      let originPoint = routePoints[0]
      let timeZone = originPoint.timeZone || 'EST'
      let timeZoneFull = originPoint.timeZoneFull || timeZone
      let list = routes.slice(0, 3).map((item, index) => {
        return {
          ...item,
          isActive: index === 0
        }
      })
      return list.map(item => {
        const points = this.calculateShape(item)
        const drivingTime = item.summary.duration
        const drivingTimeHours = parseInt(drivingTime / 3600)
        const drivingTimeMinutes = Math.round((drivingTime - drivingTimeHours * 3600) / 60)
        const estimatedArrivalTime = moment(item.summary.arrival, 'X').tz(getTimeZone(timeZoneFull)).format('HH:mm')
        let waypointList = this.getRouteWaypoint(item, routePoints)
        return {
          ...item,
          points: Object.freeze(points),
          totalCost: item.summary.totalCost,
          distance: item.summary.distance,
          timeZone,
          timeZoneFull,
          drivingTimeHours,
          drivingTimeMinutes,
          estimatedArrivalTime,
          waypointList,
          api: 'serverRouting',
          routeType: 'ordinary' // 路线类型：ordinary:普通路线,fuelLoading:开始加载fuel plan数据,fuelError:加载失败, fuelSuccessful:加载成功,fuelPlan:fuel plan路线
        }
      })
    } catch (error) {
      console.log(error)
      return []
    }
  }
  formatRouteSetting(setting) {
    return [...setting].sort()
  }
  formatRouteWaypoint(points) {
    return points.filter(item => item.value)
  }
  formatActiveRoute(routes) {
    let activeRoute = routes.filter(item => item.isActive)
    return activeRoute.map(item => {
      let obj = { routeType: 'ordinary',  shape: item.shape }
      if (item.routeType === 'fuelPlan') {
        obj = Object.assign(obj, {
          routeType: item.routeType,
          fuelPlanRouteShape: item.fuelPlanRoute.shape
        })
      }
      return obj
    })
  }
  /** 
   * 判断路线是否相同
   * @param {tripPlanInfo} route_1
   * @param {tripPlanInfo} route_2
   * @returns {Boolean}
  */
  determineTripPlanIsSame(route_1, route_2) {
    let routeInfo_1 = {
      wayPoints: this.formatRouteWaypoint(route_1.tripPlanPoints),
      settings: this.formatRouteSetting(route_1.settingList),
      truckInfo: route_1.truckInfo,
      route: this.formatActiveRoute(route_1.routes)
    }
    let routeInfo_2 = {
      wayPoints: this.formatRouteWaypoint(route_2.tripPlanPoints),
      settings: this.formatRouteSetting(route_2.settingList),
      truckInfo: route_2.truckInfo,
      route: this.formatActiveRoute(route_2.routes)
    }
    return isEqual(routeInfo_1, routeInfo_2)
  }
  serverRoutingFormatRoute(waypoint, route) {
    return this.formatCalculateRouteResult(parseServerRoutingResp(route), waypoint)
  }
  judgeWhetherSame(point_1, point_2) {
    try {
      return point_1.uniqueIdentifier === point_2.uniqueIdentifier
      && point_1.latitude === point_2.latitude
      && point_1.longitude === point_2.longitude
    } catch {
      return false
    }
  }
  getWaypointList(newList, oldList) {
    let _i = 0
    return newList.map((item, index) => {
      let _oldPoint = oldList[index + _i]
      let _nextOldPoint = oldList[index + _i + 1]
      let _nextPoint = newList[index + 1]
      if (this.judgeWhetherSame(item, _oldPoint)) {
        if (this.judgeWhetherSame(_nextPoint, _nextOldPoint)) {
          return item
        }
      } else if (this.judgeWhetherSame(item, _nextOldPoint)) {
        // Delete a point
        if (this.judgeWhetherSame(_nextPoint, oldList[index + _i + 2])) {
          return item
        }
        _i++
      } else if (this.judgeWhetherSame(_nextPoint, _oldPoint)) {
         // Add a point
         _i--
      }
      return { ...item, via: [] }
    })
  }
}

export default tripPlanService
